import { useMemo } from "react";
import { formatDisplay } from "@/utils/format-display";
import Spinner from "../spinner";
import { useBalance } from "./data";

function Item(props: {
  src: string;
  value: string;
  isLoading: boolean;
  label: string;
}) {
  const { src, value, isLoading, label } = props;

  return (
    <div
      className="col-span-1 border border-[#24201C] border-b-0 rounded-t-xl flex flex-col gap-1 bg-[#0C0703]"
      data-category="Redirect"
      data-label={label}
      data-action="redirect_holdstation_wallet"
      onClick={() => {
        window.open(
          "https://world.org/mini-app?app_id=app_0d4b759921490adc1f2bd569fda9b53a",
          "_blank"
        );
      }}
    >
      <div className="flex flex-row items-center justify-between gap-1">
        <div className="flex-1 self-stretch  border border-[#24201C] rounded-br-xl flex items-center justify-center border-t-0 border-l-0">
          {isLoading ? (
            <Spinner className="w-3 h-3" />
          ) : (
            <p className="text-[#AD9883] text-xs font-semibold italic leading-[18px] text-center p-0.5">
              x{formatDisplay(Number(value), { decimalToShow: 0 })}
            </p>
          )}
        </div>
        <div className="w-8 flex-none self-stretch  border border-[#24201C] border-t-0 border-r-0  rounded-bl-xl flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
          >
            <g clipPath="url(#clip0_21387_15655)">
              <path
                d="M12.0001 3.33325C12.1769 3.33325 12.3465 3.40349 12.4715 3.52851C12.5965 3.65354 12.6668 3.82311 12.6668 3.99992V9.33325C12.6668 9.51006 12.5965 9.67963 12.4715 9.80466C12.3465 9.92968 12.1769 9.99992 12.0001 9.99992C11.8233 9.99992 11.6537 9.92968 11.5287 9.80466C11.4037 9.67963 11.3335 9.51006 11.3335 9.33325V5.60925L4.70012 12.2426C4.57439 12.364 4.40598 12.4312 4.23119 12.4297C4.05639 12.4282 3.88918 12.3581 3.76557 12.2345C3.64197 12.1109 3.57186 11.9436 3.57034 11.7689C3.56882 11.5941 3.63601 11.4257 3.75745 11.2999L10.3908 4.66659H6.66679C6.48998 4.66659 6.32041 4.59635 6.19538 4.47132C6.07036 4.3463 6.00012 4.17673 6.00012 3.99992C6.00012 3.82311 6.07036 3.65354 6.19538 3.52851C6.32041 3.40349 6.48998 3.33325 6.66679 3.33325H12.0001Z"
                fill="#AD9883"
              />
            </g>
            <defs>
              <clipPath id="clip0_21387_15655">
                <rect width={16} height={16} fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div className="h-12 overflow-hidden flex items-center justify-center">
        <img src={src} className="h-14 -mb-2" alt="eggs" />
      </div>
    </div>
  );
}

export function Balance() {
  const { data, isLoading } = useBalance();
  const [common, rare, mythic] = useMemo(() => {
    return [data[0], data[1], data[2]];
  }, [data]);

  return (
    <div className="grid grid-cols-3 border-b border-[#24201C] px-4 gap-2 pt-4">
      <Item {...common} isLoading={isLoading} label="Common Egg" />
      <Item {...rare} isLoading={isLoading} label="Rare Egg" />
      <Item {...mythic} isLoading={isLoading} label="Mythic Egg" />
    </div>
  );
}
